$(function() {
  console.log('layout.js');

  // タブレットレイアウトをPCと統一
  var metaDiscre = document.head.children;
  var metaLength = metaDiscre.length;
  if(window.outerWidth > 700 && window.outerWidth < 1200){
    for(var i = 0;i < metaLength;i++){
       var proper = metaDiscre[i].getAttribute('name');
        if(proper === 'viewport'){
          var dis = metaDiscre[i];
          dis.setAttribute('content','width=1200');
        }
    }
  }

  //トップに戻るボタン + スクロール + ウィンドウサイズ系の対策処理
  function scrollAnimationSet(target) {
    const scButtonWrap = $('#scrollTopWrap');
    const indexProducts = document.getElementById("indexProducts");
    const position = document.documentElement;
    let wHeight = window.innerHeight;
    let preSetWidth = window.innerWidth;
    let scrollCount = 0;

    function setHeightProperty() {
      wHeight = window.innerHeight;
      position.style.setProperty('--wHeight', window.innerHeight);
      position.style.setProperty('--wHeightPx', window.innerHeight + 'px');
      position.style.setProperty('--scroll', window.scrollY);
      if(window.scrollY > window.innerHeight){
        scButtonWrap.addClass('display');
      }else{
        scButtonWrap.removeClass('display');
      }
      if (document.getElementById('index')) {
        var targetHeight = indexProducts.offsetTop;
        if(window.scrollY > targetHeight){
          $('header').removeClass('index');
        }else{
          $('header').addClass('index');
        }
      }
      requestAnimationFrame(setHeightProperty);
    }

    function setProperties() {
      setHeightProperty();
    }

    function init() {
      /*const scrollButton = document.querySelector('#returnTop');
      scrollButton.addEventListener( 'click' , scrollTop );*/
      function scrollTop(){
        window.scroll({top: 0, behavior: 'smooth'});
      };
      var timer = false;
      setProperties();
      position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
      setProperties();
    }

    init();

  }

  scrollAnimationSet($('article'));

  // LP メインスライダー
  function mainSliderControll(target){
    var slideImg = [];
    var slideLength;
    var currentSlide = 0;

    function changeSlide(e){
      $('.display-slide').removeClass('display-slide');
      slideImg[e].addClass('display-slide');
      if(currentSlide < slideLength){
        currentSlide = currentSlide + 1;
      }else{
        currentSlide = 0;
      }
      setTimeout(function() {
        changeSlide(currentSlide);
      }, 4000);
    }

    function init(){
      $.each(target.find('.slide_box'), function(index) {
        slideImg[index] = $(this);
        slideLength = index;
      });

      changeSlide(0);
    }

    init();

  }

  if (document.getElementById('mainSlider')) {
    mainSliderControll($('#mainSlider'));
  }

  // 商品詳細レイアウト サムネイルの切り替え
  function thumbSwitcher(target){
    let thumbButton = [];
    let thumbSrc = [];
    let thumbAlt = [];
    let thumbSrcSet = [];
    let thumbBox = target.find('.thumb_img');
    let caption = target.find('.caption');
    let thumbImage = thumbBox.find('img');
    const time = 300;

    function switchImage(num){
      thumbImage.stop().animate({ opacity: 0 }, time, function() {
          thumbImage.attr('src', thumbSrc[num]);
          thumbImage.attr('srcset', thumbSrcSet[num]);
          $('.active_thumb').removeClass('active_thumb');
          thumbButton[num].addClass('active_thumb');
          caption.html(thumbAlt[num]);
          thumbImage.stop().animate({ opacity: 1 }, time);
      });
    }

    function thumbHeightControll(){
      var thumbHeight = thumbImage.outerHeight();
      /*$('#thumnails').css({'max-height': thumbHeight + 'px'});*/
      /*requestAnimationFrame(thumbHeightControll);*/
    }

    function init(){
      thumbHeightControll();
      $.each(target.find('button'), function(index) {
        thumbButton[index] = $(this);
        thumbSrc[index] = $(this).find('img').attr("src");
        thumbSrcSet[index] = $(this).find('img').attr("srcset");
        thumbAlt[index] = $(this).find('img').attr("alt");
        thumbButton[index].on({
          'click': function() {
            switchImage(index);
          }
        });
      });
      $(window).on({
        'resize': function(){
          thumbHeightControll();
        }
      });
    }

    init();

  }

  if (document.getElementById('thumbnails01')) {
    thumbSwitcher($('#thumbnails01'));
  }

  if (document.getElementById('thumbnails02')) {
    thumbSwitcher($('#thumbnails02'));
  }

  //FAQ よくある質問
  function faqToggle(target) {
    var toggleItem = [];
    var toggleButton = [];
    var toggleContents = [];
    var toggleHeight = [];
    var toggleState = [];
    var toggleTitleTxt = [];
    var toggleContentsTxt = [];
    var faqSearch = $('#faqSearch');
    var faqFlex = $('#faqFlex');
    var windowW = window.innerWidth;

    function toggleMove(e) {
      if ( toggleState[e] == 0 ) {
        toggleItem[e].addClass('active');
        var buttonHeight = toggleButton[e].outerHeight();
        var targetHeight = toggleHeight[e].outerHeight();
        toggleItem[e].css({
          'height': buttonHeight + targetHeight + 'px'
        });
        toggleContents[e].css({
          'height': targetHeight + 'px'
        });
        toggleState[e] = 1;
      } else {
        toggleItem[e].removeClass('active');
        var buttonHeight = toggleButton[e].outerHeight();
          toggleItem[e].css({
            'height': buttonHeight + 'px'
          });
          toggleContents[e].css({
            'height': '0px'
          });
        toggleState[e] = 0;
      }
    }

    function setToggleHeight(){
      $.each(target.find('.toggle_item'), function(index) {
        toggleItem[index].removeClass('active');
        toggleItem[index] = $(this);
        toggleButton[index] = $(this).find('.toggle_button');
        toggleContents[index] = $(this).find('.toggle_contents');
        toggleHeight[index] = $(this).find('.contents_inner');
        toggleContents[index].css({'height': 0 + 'px'});
        $(this).css({'height': toggleButton[index].outerHeight() + 2 + 'px'});
        toggleState[index] = 0;
      });
    }

    function init() {
      $.each(target.find('.toggle_item'), function(index) {
        toggleItem[index] = $(this);
        toggleButton[index] = $(this).find('.toggle_button');
        toggleContents[index] = $(this).find('.toggle_contents');
        toggleHeight[index] = $(this).find('.contents_inner');
        $(this).css({'height': toggleButton[index].outerHeight() + 2 + 'px'});
        toggleState[index] = 0;
        toggleTitleTxt[index] = toggleButton[index].text();
        toggleContentsTxt[index] = toggleContents[index].text();
        toggleButton[index].on({
          'click': function() {
            toggleMove(index);
          }
        });
      });


      $(window).on(
        'resize', function() {
          setToggleHeight();
        }
      );
    }

    init();

  }

  if (document.getElementById('faqWrap')) {
    faqToggle($('body'));
  }


  //カートページ 購入個数の増減
  function controllProductQuantity(target){
    var minusButton = [];
    var plusButton = [];
    var quantityInput = [];
    var reloadButton = [];
    var quantityNum;

    function controllQuantity(num, vector){
      quantityNum = quantityInput[num].val();
      if(vector == 1){
        quantityInput[num].attr('value', Number(quantityNum) + 1);
        reloadButton[num].click();
      }else{
        if(quantityNum != 1){
          quantityInput[num].attr('value', Number(quantityNum) - 1);
          reloadButton[num].click();
        }
      }
    }

    function init(){
      $.each(target.find('.cart_item'), function(index) {
        minusButton[index] = $(this).find('.minus');
        plusButton[index] = $(this).find('.plus');
        quantityInput[index] = $(this).find('input[type="number"]');
        reloadButton[index] = $(this).find('.reload_button');
        minusButton[index].on({
          'click': function() {
            controllQuantity(index, -1);
          }
        });
        plusButton[index].on({
          'click': function() {
            controllQuantity(index, 1);
          }
        });
      });

    }

    init();

  }

  if (document.getElementById('cartItem')) {
    controllProductQuantity($('#cartItem'));
  }

  //インタビューのポップアップ
  function userVoicePopDisplay(target){
    var interviewPop = $('#interviewPop');
    var interviewClose = $('#interviewClose');
    var interviewBg = $('#interviewBg');
    var interviewButton = [];
    var interviewButtonHref = [];


    function voicePopOpen(e){
      interviewPop.addClass('open');
      $.ajax({
        url: 'https://dears-check.com/pages/' + interviewButtonHref[e],
        cache: false,
        dataType: 'html',
        success: function(html) {
          console.log('https://dears-check.com/pages/' + interviewButtonHref[e]);

          var interviewContents = $(html).find('#interViewContents').html();
          $('#interViewContents').html(interviewContents);

          setTimeout(function() {
            interviewPop.addClass('loaded');
          }, 500);
        },
      }).fail(function(){
        //失敗した時の処理を記述
      });
    }

    function voicePopClose(){
      interviewPop.removeClass('open');
      setTimeout(function() {
        interviewPop.removeClass('loaded');
        $('#interViewContents').html('');
        $('.detail_inner').scrollTop(0);
      }, 500);
    }


    function init(){
      $.each(target.find('button'), function(index) {
        interviewButton[index] = $(this);
        interviewButtonHref[index] = $(this).attr('link')
        $(this).on({
          'click': function() {
            voicePopOpen(index);
          }
        });
      });

      interviewClose.on({
        'click': function() {
          voicePopClose();
        }
      });

      interviewBg.on({
        'click': function() {
          voicePopClose();
        }
      });

    }

    init();

  }

  if (document.getElementById('userVoice')) {
    userVoicePopDisplay($('#userVoice'));
  }



});


